import Booking from './booking'
import { updateBookingStepper } from './booking-stepper'
import { showFormFeedback } from './helpers/showFormFeedback'
import { selectOption } from './booking-components/payment-options'
import { showLoadingSpinner, hideLoadingSpinner } from './helpers/loadingSpinner'
import {
    trackBeginCheckout,
    trackBookingPageView,
    trackViewCart,
} from '../analytics/holidayParkDataLayer'

class BookingManager {
    constructor() {
        const SCROLL_TO_TOP = false

        this.bookingPage = document.querySelector('#holiday-park-booking-page')
        this.contactInfo = this.bookingPage.querySelector('#booking-info')
        this.confirmBooking = this.bookingPage.querySelector('#confirm-booking')
        this.extras = this.bookingPage.querySelector('#extras-page')
        this.paymentInfo = this.bookingPage.querySelector('#payment-info')
        this.bookingSummary = this.bookingPage.querySelector('#booking-summary')
        this.formFeedback = this.bookingPage.querySelector('#form-feedback')
        this.nextButton = this.bookingPage.querySelector('#next-button')
        this.backButton = this.bookingPage.querySelector('#back-button')
        this.restartButton = this.bookingPage.querySelector('#restart-button')
        this.bookingStepper = this.bookingPage.querySelector('#booking-stepper')
        this.loadingSpinner = this.bookingPage.querySelector('#loading-spinner')
        this.errorPage = this.bookingPage.querySelector('#error-page')
        this.bookingStates = [this.contactInfo, this.extras,this.confirmBooking, this.paymentInfo]
        this.bookingStatesSize = this.bookingStates.length - 1
        this.currentState = -1
        this.bookingNo = this.bookingPage.dataset.booking_id
        this.booking = new Booking(this.contactInfo, this.extras, this.confirmBooking, this.paymentInfo, this.bookingNo, this.bookingSummary)
        this.addEventListenersToButtons()
        trackBookingPageView()
        this.goToNextStage(1, SCROLL_TO_TOP)

        const errors = this.bookingPage.querySelector('#form-errors')
        if (errors) {
            const paymentOption = errors?.querySelector("#payment-option")?.dataset?.option ?? null
            if (paymentOption == "true" || paymentOption == "false") {
                const depositSelected = paymentOption == "true" ? true : false
                selectOption(depositSelected)
            }

            const SCROLL_TO_TOP = false
            const PAYMENT_INFO_STAGE = 3
            this.goToNextStage(PAYMENT_INFO_STAGE, SCROLL_TO_TOP)
        }
    }

    addEventListenersToButtons() {
        this.nextButton.addEventListener("click", (event) => {
            event.stopPropagation();
            event.preventDefault();
            this.next()
        });

        this.backButton.addEventListener("click", (event) => {
            event.stopPropagation();
            event.preventDefault();
            this.back()
        });
    }

    next() {
        if (this.currentState < this.bookingStatesSize) {
            this.changeState(1)
        }

    }

    back() {
        if (this.currentState > 0) {
            this.changeState(-1)
        }
    }

    scrollToTop() {
        window.scrollTo({top: 0, left: 0, behavior: "smooth" });
    }

    hideAllPages() {
        this.hideElement(this.contactInfo)
        this.hideElement(this.extras)
        this.hideElement(this.confirmBooking)
        this.hideElement(this.paymentInfo)
    }

    showElement(element) {
        element.classList.remove('hidden')
    }

    hideElement(element) {
        element.classList.add('hidden')
    }

    updateButtons() {
        this.hideElement(this.backButton)
        this.hideElement(this.nextButton)

        if (this.currentState > 0) {
            this.showElement(this.backButton)
        }
        if (this.currentState < this.bookingStatesSize) {
            this.showElement(this.nextButton)
        }
        if (this.currentState == this.bookingStatesSize - 1) {
            this.nextButton.querySelector('.button-text').innerHTML = "<strong>Confirm</strong>"
        }
        else {
            this.nextButton.querySelector('.button-text').innerHTML = "Next"
        }
    }

    checkIfPaymentPage() {
        if (this.currentState == this.bookingStatesSize) {
            this.hideElement(this.backButton)
            // this.hideElement(this.bookingSummary)
        }
    }

    async goToNextStage(value, scrollToTop = true) {
        if (scrollToTop) {
            this.scrollToTop()
        }
        this.currentState += value
        this.updateButtons()
        updateBookingStepper(this.bookingStepper, this.currentState)
        this.checkIfPaymentPage()
        this.hideAllPages()
        showLoadingSpinner()

        let currentStage = true
        let nextStage = true
        if (Math.sign(value) == 1) {
            await this.booking.updateBookingStage(this.currentState)
            await this.booking.updateNextBookingStage(this.currentState)
        }
        hideLoadingSpinner()

        if (currentStage && nextStage) {
            this.showElement(this.bookingStates[this.currentState])
            this.trackAnalyticsForCurrentStage()
        }
        else {
            this.showElement(this.errorPage)
            this.hideElement(this.nextButton)
            this.hideElement(this.backButton)
            this.showElement(this.restartButton)
        }

        this.clearFormFeedback()
    }

    async changeState(value) {
        const validation = this.booking.validateFields(this.currentState + 1)
        if (validation.valid) {
            await this.goToNextStage(value)
        }
        else {
            showFormFeedback(validation)
        }
    }

    clearFormFeedback() {
        this.formFeedback.textContent = ""
    }

    trackAnalyticsForCurrentStage() {
        if (this.currentState === 0) {
            trackBeginCheckout()
            return
        }

        if (this.currentState === 2) {
            trackViewCart()
        }
    }
}

function isBookingPage() {
    return document.querySelector('#holiday-park-booking-page')
}

window.addEventListener("DOMContentLoaded", (event) => {
    if (isBookingPage()) {
        const bookingManager = new BookingManager()
    }
});

// export default (new BookingManager)
